import { createContext, useContext } from 'react';

const AccountShellContext = createContext(null);

export function AccountShellProvider({ value, children }) {
  return (
    <AccountShellContext.Provider value={value}>
      {children}
    </AccountShellContext.Provider>
  );
}

export function useAccountShell() {
  return useContext(AccountShellContext) || {};
}
